export const TOOLTIP = {
  PROCESSING: 'You can download your export file here in a few minutes',
  SUCCESS: 'New export is ready for download',
  ERROR: 'Error generating report',
}
